/**
 * 课程筛选结果
 */
export default {
  loadMoreButtonName: '더 보기',
  errorNotice: '로드 실패, 다시 시도해주세요.',
  emptyNotice: '이 카테고리에는 강의가 없습니다. 다른 학년/학년별 강의를 찾아보세요.',
}
